import React from 'react';
import {
  FaFacebook,
  FaInstagram,
  FaTiktok,
  FaXTwitter,
  FaYoutube,
} from 'react-icons/fa6';

const socialLinks = [
  { label: 'Instagram', href: 'https://www.instagram.com/aarjay__s/', IconComponent: FaInstagram },
  { label: 'Facebook', href: 'https://www.facebook.com/profile.php?id=61581285654908', IconComponent: FaFacebook },
  { label: 'YouTube', href: 'https://www.youtube.com/@Aarjay_S', IconComponent: FaYoutube },
  { label: 'X', href: 'https://x.com/Aarjay__S', IconComponent: FaXTwitter },
  { label: 'TikTok', href: 'https://www.tiktok.com/@aarjay_s', IconComponent: FaTiktok },
];

const quickLinks = [
  { label: 'Home', id: 'home' },
  { label: 'About', id: 'about' },
  { label: 'Books', id: 'books' },
  { label: 'Coming Soon', id: 'coming-soon' },
  { label: 'Testimonials', id: 'testimonials' },
  { label: 'Contact', id: 'contact' },
];

const Footer: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="footer">
      <div className="wrapper">
        <div className="footer__top">
          <div className="stack" style={{ gap: '0.75rem' }}>
            <div className="brand-mark">
              <span className="brand-mark__icon">A</span>
              Aarjay S
            </div>
            <p className="text-muted" style={{ margin: 0 }}>
              I write fiction that honours the brave tenderness of human connection—love, friendship,
              kinship—and every fragile bond that refuses to be ordinary.
            </p>
            <div className="social-links">
              {socialLinks.map((item) => {
                const Icon = item.IconComponent as React.ComponentType;
                return (
                  <a
                    key={item.label}
                    href={item.href}
                    className="icon-button"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={item.label}
                  >
                    <Icon />
                  </a>
                );
              })}
            </div>
          </div>

          <div className="stack" style={{ gap: '0.75rem' }}>
            <h4 style={{ margin: 0, fontFamily: 'Cormorant Garamond, serif' }}>Site Map</h4>
            <div className="link-row">
              {quickLinks.map((link) => (
                <button
                  key={link.id}
                  type="button"
                  className="pill-link"
                  onClick={() => scrollToSection(link.id)}
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          <div className="stack" style={{ gap: '0.75rem' }}>
            <h4 style={{ margin: 0, fontFamily: 'Cormorant Garamond, serif' }}>Where to Buy</h4>
            <p className="text-muted" style={{ margin: 0 }}>
              <em>The Arid Lips: After the Last Kiss</em> is available globally. A substantial share
              of the royalties will be donated to organizations supporting mental health initiatives.
            </p>
            <div className="btn-row">
              <a
                href="https://www.amazon.com/dp/B0FD369KK8"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn--ghost"
              >
                Amazon US
              </a>
              <a
                href="https://www.amazon.in/dp/B0FD369KK8"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn--ghost"
              >
                Amazon India
              </a>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <span>© {new Date().getFullYear()} Aarjay S. All rights reserved.</span>
          <div className="link-row">
            <a
              className="pill-link"
              href="mailto:aarjay.scribe@yahoo.com"
            >
              Contact
            </a>
            <a
              className="pill-link"
              href="https://www.amazon.com/dp/B0FD369KK8"
              target="_blank"
              rel="noopener noreferrer"
            >
              Amazon Listing
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

